import { rest } from "msw";
import { getBigFileUploadEndpoint } from "../utils/endpoint";

export default rest.post(getBigFileUploadEndpoint, (req, res, ctx) => {
  console.log("get big file upload: ");
  return res(ctx.status(204, "Mocked status"), ctx.delay(500));
});
